import React, { useEffect, useRef, useState } from 'react';

import IbTextArea from '../IbTextArea';

interface IRegexPatternsEditorProps {
  patterns?: string[];
  hasError?: boolean;
  onChange: (patterns: string[]) => void;
  onBlur: () => void;
}

const parseRegexPatternsInput = (value: string): string[] =>
  value
    .replace(/\r\n?/g, '\n')
    .split('\n')
    .filter((item) => item.length);

const RegexPatternsEditor: React.FC<IRegexPatternsEditorProps> = ({ patterns, hasError, onChange, onBlur }) => {
  const patternsText = (patterns ?? []).join('\n');
  const [patternsInput, setPatternsInput] = useState(patternsText);
  const lastParsedPatternsTextRef = useRef(patternsText);

  useEffect(() => {
    if (patternsText === lastParsedPatternsTextRef.current) {
      return;
    }

    setPatternsInput(patternsText);
    lastParsedPatternsTextRef.current = patternsText;
  }, [patternsText]);

  const onPatternsChange = (value: string) => {
    setPatternsInput(value);
    const parsedPatterns = parseRegexPatternsInput(value);
    lastParsedPatternsTextRef.current = parsedPatterns.join('\n');
    onChange(parsedPatterns);
  };

  return (
    <IbTextArea
      rows={6}
      status={hasError ? 'error' : 'default'}
      value={patternsInput}
      onBlur={onBlur}
      onChange={onPatternsChange}
    />
  );
};

export default RegexPatternsEditor;
